import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { Permiso } from '../../../../main/utilerias/models/usuarios/permiso';
import { AuthService } from '../../../services/auth.service';

@Component({
  selector: 'app-confirm-dialog',
  templateUrl: './confirm-dialog.component.html',
  styleUrls: ['./confirm-dialog.component.scss']
})
export class ConfirmDialogComponent {

  title: string;
  message: string;
  permisos: Permiso;

  /**
   * Constructor por defecto.
   * @param dialogRef referencia al mismo mat dialog.
   * @param data Valores que enviamos desde cualquier componente para asignar el titulo y el mensaje.
   */
  constructor(private dialogRef: MatDialogRef<ConfirmDialogComponent>, @Inject(MAT_DIALOG_DATA) data, private authService: AuthService) {
    this.title = data.title;
    this.message = data.message;
    
    this.permisos = this.authService.obtenerPermisoPorOpcion('Usuarios');
  }

  

  /**
   * Al aceptar cualquier accion enviamos true de que se desea proceder con la accion.
   */
  aceptar(): void {
    this.dialogRef.close(true);
  }

  /**
   * Al cancelar la operacion enviamos false para que no se realice ninguna accion.
   */
  cancelar(): void {
    this.dialogRef.close(false);
  }

}
